import {AnyAction} from 'redux'
import {setSiteSettings, updateSiteSettings} from '../actions/site-settings'
import {SiteSettings} from '../types/state'

const defaultState: SiteSettings = {} as SiteSettings

export const siteSettings = (state = defaultState, action: AnyAction): SiteSettings => {
  switch (action.type) {
    case setSiteSettings.toString():
    case updateSiteSettings.fulfilled.toString():
      return action.payload.settings
    default:
      return state
  }
}
